export default function generateDisplayName(component) {
  var displayName = component.displayName || component.name;

  if (displayName) {
    return 'Fela' + displayName;
  }

  return 'ConnectedFelaComponent';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/generateDisplayName.js
// module id = 840
// module chunks = 1